/**
 * Favicon Generator Utility
 * Creates favicon assets programmatically
 */

export const generateFaviconCanvas = (size = 32) => {
  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext('2d');
  
  // Clear canvas
  ctx.clearRect(0, 0, size, size);
  
  // Jamaica gradient background
  const gradient = ctx.createLinearGradient(0, 0, size, size);
  gradient.addColorStop(0, '#009639'); // Jamaica Green
  gradient.addColorStop(1, '#FFD700'); // Jamaica Gold
  
  // Draw circle
  ctx.beginPath();
  ctx.arc(size/2, size/2, size/2 - 2, 0, 2 * Math.PI);
  ctx.fillStyle = gradient;
  ctx.fill();
  
  // White border
  ctx.strokeStyle = '#FFFFFF';
  ctx.lineWidth = Math.max(1, size / 32);
  ctx.stroke();
  
  // "JD" text
  ctx.fillStyle = '#FFFFFF';
  ctx.font = `bold ${size * 0.35}px Arial, sans-serif`;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  
  // Text shadow for better visibility
  ctx.strokeStyle = '#009639';
  ctx.lineWidth = Math.max(0.5, size / 64);
  ctx.strokeText('JD', size/2, size/2);
  ctx.fillText('JD', size/2, size/2);
  
  return canvas;
};

export const generateAndDownloadFavicon = (size = 32, filename = `favicon-${size}x${size}.png`) => {
  const canvas = generateFaviconCanvas(size);
  
  // Create download link
  const link = document.createElement('a');
  link.download = filename;
  link.href = canvas.toDataURL('image/png');
  
  // Auto-download
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  
  return canvas.toDataURL('image/png');
};

export const generateAllFaviconSizes = () => {
  const sizes = [16, 32, 48, 64, 96, 128, 192, 256, 512];
  const generated = {};
  
  sizes.forEach(size => {
    const canvas = generateFaviconCanvas(size);
    generated[size] = canvas.toDataURL('image/png');
  });
  
  return generated;
};

export const setFaviconFromCanvas = (canvas) => {
  const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
  link.type = 'image/x-icon';
  link.rel = 'shortcut icon';
  link.href = canvas.toDataURL('image/x-icon');
  
  if (!document.querySelector("link[rel*='icon']")) {
    document.head.appendChild(link);
  }
};

// Generate default favicon on module load
export const initializeDefaultFavicon = () => {
  const canvas = generateFaviconCanvas(32);
  setFaviconFromCanvas(canvas);
};